export default __webpack_public_path__ + "static/media/Blue-Android-5.d8502cd8.png";